import { defineNuxtPlugin, useNuxtApp, useState } from "nuxt/app";

type PortalClientConfig = {
	portalType: string;
	apiBase: string;
	cdnUrl: string;
};

export default defineNuxtPlugin(() => {
	if (!import.meta.server) {
		return;
	}

	const nuxtApp = useNuxtApp();
	const portalState = useState<PortalClientConfig | null>("portalConfig", () => null);
	const portal = nuxtApp.ssrContext?.event.context.portal;

	if (!portal) {
		return;
	}

	portalState.value = {
		portalType: portal.portalType,
		apiBase: portal.apiBase,
		cdnUrl: portal.cdnUrl
	};
});
